import  { useState, useEffect } from 'react';
import {  Table, TableBody, Box, TableCell, TableContainer, TableHead, TableRow,  Tooltip, IconButton } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useTheme, Divider } from "@mui/material";

import dayjs from "dayjs";
import TableSortLabel from "@mui/material/TableSortLabel";
import Header from "../../../Layout/Header";
// import { API_ENDPOINTS } from "../../../config/api/apiCall"";
// import { callApi } from "../../commonapicall/fetchdata";
import CallAlertBar from "../../../Layout/Alertbar";

import { tokens } from "../../../theme/theme";
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
const ViewOvertime = ({ handleBackWinderMachineEntry }) => {
  const [overtimeRecords, setOvertimeRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const ViewHideMsg = (msg, securityvalue, open) => {
    setParentRollSeverityvalue(securityvalue);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(securityvalue);
    setParentRollMsgOpen(open);
  }


  const fetchPendingOvertimeRequests = async () => {
    const companyid = localStorage.getItem('companyid');

    callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeOvertimeRequestList, 'POST', { 'Content-Type': 'application/json' }, companyid)
      .then(data => {
        if (data?.length) {
          setOvertimeRecords(data);
        }
      })
      .catch(error => alert(error.message));
  };


  useEffect(() => {
    // Fetch overtime records from the backend
    // API call to get overtime records from the database

    fetchPendingOvertimeRequests();
  }, []);



  const filteredRecords = overtimeRecords.filter((record) =>
    record.employee_fullname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAction = async (id, status) => {
    // Show a confirmation prompt
    const confirmation = window.confirm(`Are you sure you want to ${status.toLowerCase()} this overtime request?`);

    if (!confirmation) {
      // If the user cancels, do nothing
      return;
    }

    const managerId = localStorage.getItem('userID');

    const params = {
      id_overtime: id,
      id_employee: 0,
      id_shift: 0,
      duration_mins: 0,
      id_approved_by: 0,
      approval_status: status,
      approved_by: managerId
    };

    callApi(API_ENDPOINTS.EMPLOYEE_UpdateEmployeeOvertimeRequestStatus, 'POST', { 'Content-Type': 'application/json' }, params)
      .then(data => {
        if (data?.length) {
          if (data === 'Overtime request status updated successfully!') {
            ViewHideMsg(data, 'success', true);
            fetchPendingOvertimeRequests();
          }
          else {
            ViewHideMsg(data, 'warning', true);
          }
        }
      })
      .catch(error => alert(error.message));

  };

  const [orderBy, setOrderBy] = useState("employee_fullname"); // Default sorting column
  const [orderDirection, setOrderDirection] = useState("asc"); // 'asc' or 'desc'

  // Sorting function
  const handleSort = (column) => {
    const isAsc = orderBy === column && orderDirection === "asc";
    setOrderBy(column);
    setOrderDirection(isAsc ? "desc" : "asc");
  };

  // Apply sorting to records
  const sortedRecords = overtimeRecords.sort((a, b) => {
    const valueA = a[orderBy];
    const valueB = b[orderBy];

    if (valueA === null || valueB === null) return 0; // Handle null/undefined values

    if (typeof valueA === "string") {
      return orderDirection === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }

    if (typeof valueA === "number") {
      return orderDirection === "asc" ? valueA - valueB : valueB - valueA;
    }

    return 0;
  });

  const getStatusStyle = (status) => {
    switch (status) {
      case "Approved":
        return { color: "#90EE90", };
      case "Rejected":
        return { color: "#ff6666", };
      case "Pending":
        return { color: "#87CEEB", }; // Change to your preferred color
      default:
        return {};
    }
  };



  return (
    <Box >

      <Header title={'Employee Overtime Request'} subtitle='' callback={handleBackWinderMachineEntry} />
      <Divider />

      <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


      <Box
        gridColumn="span 9"
        gridRow={"span 2"}
        alignItems="center"
        justifyContent="center"
        padding={1}
        sx={{
          maxHeight: {
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '72vh', // Medium devices (small laptops)
            lg: '72vh', // Large devices (desktops)
            xl: '89vh', // Extra large devices (large desktops)
          },
          overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: colors.primary[400],
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: colors.blueAccent[600],
            borderRadius: '10px',
            '&:hover': {
              background: colors.blueAccent[800],
            },
          },
          '&::-webkit-scrollbar-corner': {
            background: colors.primary[700],
          },


          "& .MuiTable-root": {
            border: "none",
            size: "small",
          },
          "& .MuiTableCell-root": {
            borderBottom: "none",
            // fontWeight: "bold",
            border: "1px solid ",
            borderColor: `${colors.primary[400]} !important`,
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiTableHead-root": {
            // backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiTableBody-root": {
            overflowY: "auto",
          },
          "& .MuiCheckbox-root": {
            color: `${colors.blueAccent[200]} !important`,
            size: "small",
          },
          "& .MuiTableFooter-root": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
            height: "10px",
          },
          "& .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}>
        <TableContainer>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "employee_fullname"}
                    direction={orderBy === "employee_fullname" ? orderDirection : "asc"}
                    onClick={() => handleSort("employee_fullname")}
                  >
                    Employee Name
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "overtime_date"}
                    direction={orderBy === "overtime_date" ? orderDirection : "asc"}
                    onClick={() => handleSort("overtime_date")}
                  >
                    Overtime Date
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "duration_mins"}
                    direction={orderBy === "duration_mins" ? orderDirection : "asc"}
                    onClick={() => handleSort("duration_mins")}
                  >
                    Duration (Minutes)
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "shift_code"}
                    direction={orderBy === "shift_code" ? orderDirection : "asc"}
                    onClick={() => handleSort("shift_code")}
                  >
                    Shift
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "approval_status"}
                    direction={orderBy === "approval_status" ? orderDirection : "asc"}
                    onClick={() => handleSort("approval_status")}
                  >
                    Status
                  </TableSortLabel>
                </TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedRecords.map((record) => (
                <TableRow key={record.id_overtime}>
                  <TableCell>{record.employee_fullname}</TableCell>
                  <TableCell>
                    {dayjs(record.overtime_date).format("DD-MMM-YYYY")}
                  </TableCell>
                  <TableCell>{record.duration_mins}</TableCell>
                  <TableCell>{record.shift_code}</TableCell>


                  <TableCell style={getStatusStyle(record.approval_status)}>
                    {record.approval_status}
                  </TableCell>
                  <TableCell>
                    <Tooltip title="Approve">
                      <IconButton
                        color="success"
                        onClick={() => handleAction(record.id_overtime, "Approved")}
                        size="small"
                        style={{ marginRight: "8px" }}
                      >
                        <CheckCircleOutlineIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Reject">
                      <IconButton
                        color="error"
                        onClick={() => handleAction(record.id_overtime, "Rejected")}
                        size="small"
                      >
                        <CancelOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ViewOvertime;
